import { Object3D } from "three";
import Hotspot from "@ui/Hotspot";
import useHashLocation from "../../use-hash-location";
import { useTranslation } from "react-i18next";

import useAuth from "../../hooks/useAuth";

export const Labels = ({ data }: { data: Object3D[] }) => {
  const [_loc, setLocation] = useHashLocation();
  const { t } = useTranslation();

  const { currentUser } = useAuth();

  const handleLabelClick = (e, hotspot) => {
    e.stopPropagation();
    const isPrivate = !!hotspot.userData?.private;
    const targetId = isPrivate && !currentUser ? "./cta" : hotspot.userData?.targetId;
    if (!targetId) return;
    setLocation(targetId.startsWith("./") ? `${_loc}/${targetId.replace("./", "")}` : targetId);
  };

  return (
    <>
      {data.map((labelObject) => {
        const isPrivate = !!labelObject.userData?.private;

        return (
          <Hotspot
            position={labelObject.position}
            text={labelObject.userData.textId ? t(labelObject.userData.textId) : labelObject.name.toUpperCase()}
            topLeft
            onClick={(e) => handleLabelClick(e, labelObject)}
            delay={0}
            id={labelObject.name}
            key={labelObject.name}
            isAnimation={labelObject.userData.isAnimation}
          />
        );
      })}
    </>
  );
};
